"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SubscribeOptionLabel = require("./SubscribeOptionLabel");
Object.keys(_SubscribeOptionLabel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SubscribeOptionLabel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SubscribeOptionLabel[key];
    }
  });
});
